import { observer } from "mobx-react-lite";
import useNavigateToSaleComp from '../../hooks/useNavigateToSaleComp';
import useOpenSelectedItem from '../../hooks/useOpenSelectedItem';
import SaleCompIcon from '../icons/SaleCompIcon';
import styles from '../InfoWithIconAndNavigation.module.css';
import SaleCompInfo, { ISaleCompInfoProps } from "./SaleCompInfo";

function SaleCompInfoWithIconAndNavigation({ id, address, salePrice, pipedriveBuyerId, buildingSize, parcelSizeAcres, zoning, className, onClick, index }: ISaleCompInfoWithIconAndNavigationProps) {
    const navigateToSaleComp = useNavigateToSaleComp();

    const click = () => {
        onClick && onClick();
        navigateToSaleComp(id);
    };

    useOpenSelectedItem(index, click);

    return (
        <div className={[styles.container, className].join(" ")} onClick={click}>
            <SaleCompIcon color="#25479A" className={styles.icon} />
            <SaleCompInfo
                address={address}
                salePrice={salePrice}
                pipedriveBuyerId={pipedriveBuyerId}
                buildingSize={buildingSize}
                parcelSizeAcres={parcelSizeAcres}
                zoning={zoning}
            />
        </div>
    );
}

interface ISaleCompInfoWithIconAndNavigationProps extends ISaleCompInfoProps {
    id: number;
    index?: number;
}

export default observer(SaleCompInfoWithIconAndNavigation);